import { Box } from "@mui/material";
import { Track } from "../../types";
import PropertyDetails from "./details";
import PropertyFinancialInfo from "./financial-info/financial-info";
import PropertyPriceInfo from "./price-info/price-info-section";
import PropertyRentalInfo from "./rental-info/rental-info";
import PropertyHospitalityInfo from "./hospitality-info/hospitality-info";
import PropertyTrackScopeInfo from "./scope/scope-info";
import PageComponentsWrapper from "@/modules/common/components/wrappers/page-components-wrapper";
import { PriceRoles } from "../../dtos";
import PropertyContractStartDate from "./contract-start-date/contract-start-date";
import ConstructionProjectDetails from "./construction-project-details";

export default function PropertyOverview({ track }: { track: Track }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "24px",
        width: "100%",
        height: "100%",
      }}
    >
      <PropertyDetails track={track} />
      <PageComponentsWrapper
        page="property-details-overview"
        component="property-construction-project-details"
        trackTypeId={track.trackType.id}
      >
        <ConstructionProjectDetails projectUid={track.property.uid} />
      </PageComponentsWrapper>
      <PageComponentsWrapper
        page="property-details-overview"
        component="property-financial-info"
        trackTypeId={track.trackType.id}
      >
        <PropertyFinancialInfo property={track.property} />
      </PageComponentsWrapper>

      <PageComponentsWrapper
        page="property-details-overview"
        component="property-price-info"
        trackTypeId={track.trackType.id}
      >
        <PropertyPriceInfo
          propertyUId={track.property.uid}
          trackUid={track.uid}
          propertyPrice={{
            ...track.property.propertyPrice,
            priceRole: PriceRoles.ASKING,
          }}
          title="Client Asking Price"
        />
        <PropertyPriceInfo
          propertyUId={track.property.uid}
          trackUid={track.uid}
          propertyPrice={{
            ...track.property.propertyListingPrice,
            priceRole: PriceRoles.LISTING,
          }}
          title="Listing Price"
        />
      </PageComponentsWrapper>
      <PageComponentsWrapper
        page="property-details-overview"
        component="property-rental-info"
        trackTypeId={track.trackType.id}
      >
        <PropertyRentalInfo property={track.property} />
      </PageComponentsWrapper>
      <PageComponentsWrapper
        page="property-details-overview"
        component="property-hospitality-info"
        trackTypeId={track.trackType.id}
      >
        <PropertyHospitalityInfo property={track.property} />
      </PageComponentsWrapper>
      <PageComponentsWrapper
        page="property-details-overview"
        component="property-track-scope-info"
        trackTypeId={track.trackType.id}
      >
        <PropertyTrackScopeInfo track={track} />
      </PageComponentsWrapper>
      <PageComponentsWrapper
        page="property-details-overview"
        component="property-contract-start-date"
        trackTypeId={track.trackType.id}
      >
        <PropertyContractStartDate propertyUId={track.property.uid} />
      </PageComponentsWrapper>
    </Box>
  );
}
